import request from '@/utils/request'
// 企业列表
export function getEnterprise(params) {
  return request({
    url: 'recruit/enterprise/list',
    method: 'get',
    params,
  })
}
// 企业注册
export function RE_Register(data) {
  return request({
    url: 'recruit/enterprise/register',
    method: 'post',
    data,
  })
}
// 企业登录
export function CheckStaff(params) {
  return request({
    url: 'recruit/enterprise/loginIn',
    method: 'get',
    params,
  })
}
// 员工登录
export function CheckStaffPeople(data) {
  return request({
    url: 'OA/login',
    method: 'post',
    data,
  })
}
// 获取简历分页列表
export function RE_GetResumePage(params) {
  return request({
    url: 'system/resume/list',
    method: 'get',
    params,
  })
}
export function RE_LookRedeLiver(RDId) {
  return request({
    url: 'system/process/lookRedeliver/' + RDId,
    method: 'get',
  })
}
// 获取职位信息列表
export function RE_GetJobPage(params) {
  return request({
    url: 'system/job/list',
    method: 'get',
    params,
  })
}
// 保存职位
export function RE_SaveJob(data) {
  return request({
    url: 'system/job',
    method: 'post',
    data,
  })
}
// 获取行业类型信息列表
export function GetTindustryLists(params) {
  return request({
    url: 'system/tindustry/list',
    method: 'get',
    params,
  })
}
// 获取职业类型信息列表
export function GetAbilityLists(params) {
  return request({
    url: 'system/tability/list',
    method: 'get',
    params,
  })
}
// 获取职业类型信息列表
export function GetAbilityList(params) {
  return request({
    url: 'system/tability/dataTree',
    method: 'get',
    params,
  })
}
// 获取简历详情
export function RE_GetResume(ReId) {
  return request({
    url: 'system/resume/' + ReId,
    method: 'get',
  })
}
// 获取指定简历的求职意向列表
export function RE_GetReJobwantList(params) {
  return request({
    url: 'system/rejobwant/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的工作经历列表
export function RE_GetReWorkList(params) {
  return request({
    url: 'system/rework/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的教育经历列表
export function RE_GetReEducationList(params) {
  return request({
    url: 'system/reedu/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的项目经历列表
export function RE_GetReProjectList(params) {
  return request({
    url: 'system/reproject/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的培训经历列表
export function RE_GetReTrainList(params) {
  return request({
    url: 'system/retrain/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的语言能力列表
export function RE_GetReLanguageList(params) {
  return request({
    url: 'system/corelanguage/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的专业技能列表
export function RE_GetReSkillList(params) {
  return request({
    url: 'system/reskill/list',
    method: 'get',
    params,
  })
}
// 获取指定简历的证书列表
export function RE_GetReCertificateList(params) {
  return request({
    url: 'system/recert/list',
    method: 'get',
    params,
  })
}
// 获取指定职位的简历投递信息列表
export function RE_GetJobReDeliverList(params) {
  return request({
    url: 'system/redeliver/list',
    method: 'get',
    params,
  })
}
// 加入招聘流程
export function RE_AddCallList(RDId) {
  return request({
    url: 'system/process/addCallList/' + RDId,
    method: 'get',
  })
}
// 淘汰简历
export function RE_Eliminate(params) {
  return request({
    // url: 'system/process/eliminate',
    url: 'system/redeliver/eliminate',
    method: 'get',
    params,
  })
}
// 获取企业详情
export function RE_GetMyEnterprise(EId) {
  return request({
    url: 'recruit/enterprise/' + EId,
    method: 'get',
  })
}
// 更改密码
export function ChangePwd(params) {
  return request({
    url: 'recruit/enterprise/updatePwd',
    method: 'get',
    params,
  })
}
// 获取简历投递信息分页列表
export function RE_GetReDeliverPage(params) {
  return request({
    url: 'system/redeliver/list',
    method: 'get',
    params,
  })
}
// 保存企业信息
export function RE_SaveEnterprise(data) {
  return request({
    url: 'recruit/enterprise',
    method: 'post',
    data,
  })
}
// 获取候选人分页列表
export function RE_GetCoResumePage(params) {
  return request({
    url: 'system/process/list',
    method: 'get',
    params,
  })
}
// 获取招聘流程阶段列表
export function RE_GetRecruitStageList(params) {
  return request({
    url: 'system/process/stagelist',
    method: 'get',
    params,
  })
}
// 延期入职
export function DelayEntry(data) {
  return request({
    url: 'system/process/DelayEntry',
    method: 'post',
    data,
  })
}
// 入职
export function Entry(data) {
  return request({
    url: 'system/process/entry',
    method: 'post',
    data,
  })
}
// 不合格
export function SetUnqualified(data) {
  return request({
    url: 'system/process/setUnqualified',
    method: 'post',
    data,
  })
}
// 面试
export function RCInterview(data) {
  return request({
    url: 'system/process/rCInterview',
    method: 'post',
    data,
  })
}
// 淘汰候选人
export function Eliminate(data) {
  return request({
    url: 'system/process/eliminate',
    method: 'post',
    data,
  })
}
// 录用
export function Admission(data) {
  return request({
    url: 'system/process/admission',
    method: 'post',
    data,
  })
}
// 删除职位
export function RE_DeleteJob(JIds) {
  return request({
    url: 'system/job/' + JIds,
    method: 'delete',
  })
}
